/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetLastShift200ResponseAmountsInner } from './GetLastShift200ResponseAmountsInner';
import {
    GetLastShift200ResponseAmountsInnerFromJSON,
    GetLastShift200ResponseAmountsInnerFromJSONTyped,
    GetLastShift200ResponseAmountsInnerToJSON,
    GetLastShift200ResponseAmountsInnerToJSONTyped,
} from './GetLastShift200ResponseAmountsInner';

/**
 * 
 * @export
 * @interface GetLastShift200Response
 */
export interface GetLastShift200Response {
    /**
     * 
     * @type {string}
     * @memberof GetLastShift200Response
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetLastShift200Response
     */
    tillId: string;
    /**
     * 
     * @type {string}
     * @memberof GetLastShift200Response
     */
    tillName?: string;
    /**
     * 
     * @type {Date}
     * @memberof GetLastShift200Response
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetLastShift200Response
     */
    end: Date | null;
    /**
     * 
     * @type {number}
     * @memberof GetLastShift200Response
     */
    startAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetLastShift200Response
     */
    endAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetLastShift200Response
     */
    expectedEndAmount: number;
    /**
     * 
     * @type {Array<GetLastShift200ResponseAmountsInner>}
     * @memberof GetLastShift200Response
     */
    amounts: Array<GetLastShift200ResponseAmountsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetLastShift200Response
     */
    revenue: number;
    /**
     * 
     * @type {number}
     * @memberof GetLastShift200Response
     */
    payIns: number;
    /**
     * 
     * @type {number}
     * @memberof GetLastShift200Response
     */
    payOuts: number;
}

/**
 * Check if a given object implements the GetLastShift200Response interface.
 */
export function instanceOfGetLastShift200Response(value: object): value is GetLastShift200Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('tillId' in value) || value['tillId'] === undefined) return false;
    if (!('start' in value) || value['start'] === undefined) return false;
    if (!('end' in value) || value['end'] === undefined) return false;
    if (!('startAmount' in value) || value['startAmount'] === undefined) return false;
    if (!('expectedEndAmount' in value) || value['expectedEndAmount'] === undefined) return false;
    if (!('amounts' in value) || value['amounts'] === undefined) return false;
    if (!('revenue' in value) || value['revenue'] === undefined) return false;
    if (!('payIns' in value) || value['payIns'] === undefined) return false;
    if (!('payOuts' in value) || value['payOuts'] === undefined) return false;
    return true;
}

export function GetLastShift200ResponseFromJSON(json: any): GetLastShift200Response {
    return GetLastShift200ResponseFromJSONTyped(json, false);
}

export function GetLastShift200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLastShift200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'tillId': json['tillId'],
        'tillName': json['tillName'] == null ? undefined : json['tillName'],
        'start': (new Date(json['start'])),
        'end': (json['end'] == null ? null : new Date(json['end'])),
        'startAmount': json['startAmount'],
        'endAmount': json['endAmount'] == null ? undefined : json['endAmount'],
        'expectedEndAmount': json['expectedEndAmount'],
        'amounts': ((json['amounts'] as Array<any>).map(GetLastShift200ResponseAmountsInnerFromJSON)),
        'revenue': json['revenue'],
        'payIns': json['payIns'],
        'payOuts': json['payOuts'],
    };
}

export function GetLastShift200ResponseToJSON(json: any): GetLastShift200Response {
    return GetLastShift200ResponseToJSONTyped(json, false);
}

export function GetLastShift200ResponseToJSONTyped(value?: GetLastShift200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tillId': value['tillId'],
        'tillName': value['tillName'],
        'start': ((value['start']).toISOString()),
        'end': (value['end'] == null ? null : (value['end'] as any).toISOString()),
        'startAmount': value['startAmount'],
        'endAmount': value['endAmount'],
        'expectedEndAmount': value['expectedEndAmount'],
        'amounts': ((value['amounts'] as Array<any>).map(GetLastShift200ResponseAmountsInnerToJSON)),
        'revenue': value['revenue'],
        'payIns': value['payIns'],
        'payOuts': value['payOuts'],
    };
}

